<div
  *ngIf="alerts.length"
  class="container-fluid inter-medium position-fixed alert-container m-0 w-100 h-0"
  [ngClass]="showAsModal ? 'position-fixed alert-container-modal h-100 top-0' : ''"
>
  <div *ngFor="let alert of alerts" class="box-alert text-center my-0 mx-auto shadow-lg {{ cssClasses(alert) }}">
    <ng-container *ngIf="alert.type != alertType.InfoLogo; else DefaultAlert">
      <div class="d-flex">
        <div class="flex-grow-1 bd-highlight">
          <h6>{{ alert!.title }}</h6>
        </div>
        <div><a class="text-decoration-none close text-danger" (click)="runFunctionOnClose(alert)">x</a></div>
      </div>
      <hr class="mt-1" />
    </ng-container>
    <ng-template #DefaultAlert>
      <div class="col-12 mb-3">
        <img [src]="brandResource.logo?.path! + brandResource.logo?.pathLogoBlack" style="width: 10em" />
      </div>
    </ng-template>
    <span [innerHTML]="alert.description"></span>

    <div class="text-center" *ngIf="alert.btnText">
      <br />
      <a *ngIf="alert.btnLink" class="btn btn-auth-custom border-0 w-75" [routerLink]="alert.btnLink" (click)="removeAlert(alert)">
        {{ alert.btnText }}
      </a>
      <a *ngIf="!alert.btnLink" class="btn btn-auth-custom border-0 w-75" (click)="runFunctionOnBtnClick(alert)">
        {{ alert.btnText }}
      </a>
    </div>
  </div>
</div>
<div
  class="position-fixed fixed-top w-100 h-100 pt-5 inter-medium content-loading"
  [ngClass]="{ 'content-loading-1': loading?.loadingType == LoadingType.Gradient }"
  *ngIf="(loading?.showLoading && loading?.loadingType == LoadingType.Default) || (loading?.showLoading && loading?.loadingType == LoadingType.Gradient)"
>
  <div class="mb-5 text-center w-100 position-absolute bottom-0">
    <div class="col-md-12 loading-text fst-italic" *ngFor="let textLoading of loading?.textsLoading">
      <label>
        <strong [innerHTML]="textLoading"></strong>
      </label>
    </div>
    <div class="col-md-12 mt-2">
      <div class="spinner-grow m-1 text-dark" [ngClass]="{ 'text-white': loading?.loadingType == LoadingType.Gradient }" role="status">
        <span class="sr-only"></span>
      </div>
      <div class="spinner-grow m-1 custom-loading-icon-default" [ngClass]="{ 'custom-loading-icon-default-1': loading?.loadingType == LoadingType.Gradient }" role="status">
        <span class="sr-only"></span>
      </div>
      <div class="spinner-grow m-1 custom-loading-icon-default" [ngClass]="{ 'custom-loading-icon-default-1': loading?.loadingType == LoadingType.Gradient }" role="status">
        <span class="sr-only"></span>
      </div>
      <div class="spinner-grow m-1 text-light" role="status">
        <span class="sr-only"></span>
      </div>
    </div>
  </div>
</div>
<div class="position-fixed fixed-top w-100 h-100 inter-medium content-loading-laststep" *ngIf="loading?.showLoading && loading?.loadingType == LoadingType.Black">
  <div class="row vh-100 justify-content-around align-items-center">
    <div class="col-auto text-white text-center">Please wait while we create your {{ brandResource.brandTitle }} Profile. This will only take a moment.</div>
    <div class="mb-5 text-center position-absolute bottom-0">
      <div class="col-md-12 mt-2">
        <div class="spinner-grow m-1 text-dark" role="status">
          <span class="sr-only"></span>
        </div>
        <div class="spinner-grow m-1 custom-loading-icon-default" role="status">
          <span class="sr-only"></span>
        </div>
        <div class="spinner-grow m-1 custom-loading-icon-default" role="status">
          <span class="sr-only"></span>
        </div>
        <div class="spinner-grow m-1 text-light" role="status">
          <span class="sr-only"></span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="position-fixed fixed-top w-100 h-100 inter-medium content-loading pt-5" *ngIf="loading?.showLoading && loading?.loadingType == LoadingType.WhiteBox">
  <div class="row mt-5">
    <div class="col-md-8 offset-md-2 mt-md-5 px-4 px-md-0">
      <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4 bg-light rounded text-center p-3 mt-5">
        <div class="col-md-12 loading-text-white-box" *ngFor="let textLoading of loading?.textsLoading">
          <h3 class="inter-bold">{{ textLoading }}</h3>
        </div>
        <div class="col-md-12 mt-4">
          <div class="spinner-grow m-1 custom-loading-icon-whitebox text-dark" role="status">
            <span class="sr-only"></span>
          </div>
          <div class="spinner-grow m-1 custom-loading-icon-whitebox custom-loading-icon-whitebox-1" role="status">
            <span class="sr-only"></span>
          </div>
          <div class="spinner-grow m-1 custom-loading-icon-whitebox custom-loading-icon-whitebox-2" role="status">
            <span class="sr-only"></span>
          </div>
          <div class="spinner-grow m-1 custom-loading-icon-whitebox custom-loading-icon-whitebox-3" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div class="col-md-12">
          <p class="inter-semibold m-4 custom-loading-text-whitebox">Validating your information may take up to 45 seconds.</p>
        </div>
        <div class="col-md-12">
          <p class="inter-regular m-0 mx-3 custom-loading-text-whitebox">Please do not click the "back" button or close the browser at this time.</p>
        </div>
      </div>
    </div>
  </div>
</div>
